module.exports = __webpack_public_path__ + "static/img/001.e5a69f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/diy/001.png
// module id = onQG
// module chunks = 15